export default "__VITE_ASSET__pQhLFEbP__"